import { render, staticRenderFns } from "./SortByNew.vue?vue&type=template&id=6797b190&"
import script from "./SortByNew.vue?vue&type=script&lang=ts&"
export * from "./SortByNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports